import { Box, Button, Card, CardContent, TextField, InputAdornment, SvgIcon } from '@material-ui/core';
import { Search as SearchIcon } from 'react-feather';
import { useNavigate } from 'react-router-dom';
import Cookies from 'universal-cookie';
import Constants from 'src/utils/Constants';

const BranchListToolbar = (props) => {
  const navigate = useNavigate();
  const cookies = new Cookies();
  const user = cookies.get('umf_user');

  const navigateToAccountOptions = () => {
    navigate('/app/register/branch');
  };

  return (
    <Box {...props}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end'
        }}
      >
        {user.userType === Constants.ADMIN ? (
          <Button color="primary" variant="contained" onClick={navigateToAccountOptions}>
            Add branch
          </Button>
        ) : null}
      </Box>
    </Box>
  );
};

export default BranchListToolbar;
